import styled from "styled-components";

interface IFormGrid{ itemsLinha?: number }
export const FormGrid = styled.div<IFormGrid>`
    display: flex;
    flex-direction: row;
    gap: 20px;
    
    @media (max-width: ${(props)=> props.theme.breakpoints.laptop}) {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: ${(props)=> props.theme.breakpoints.tablet}) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: ${(props)=> props.theme.breakpoints.mobile}) {
        display: grid;
        grid-template-columns: repeat(1, 1fr);
    }
`;